import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { FC } from 'react';

export const PageLoading: FC = () => {
  return (
    <Box
      display="flex"
      flex="1"
      justifyContent="center"
      alignItems="center"
      width="100%"
      paddingY={4}
    >
      <CircularProgress aria-label="Loading" />
    </Box>
  );
};
